import { useMutation } from "@tanstack/react-query"
import { secretStorage } from "config"
import { useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { actions } from "store"
import { updateDefaultUserRolesFetch } from "store/middlewares/user.crud"
import { roleHooks } from ".."
import { toast } from "react-toastify"
import { toastConfig } from "config"

const useUpdateDefaultRole = () => {
    const dispatch = useDispatch()
    const { user } = useSelector(state => state.user)

    const selectRole = roleHooks.useSelectRole()

    const { mutateAsync: updateDefaultUserRoles, isPending } = useMutation({
        mutationFn: (val) => {
            dispatch(actions.setUpdateRoleIsPending(true))
            return updateDefaultUserRolesFetch(val)
        },
        onSettled: () => {
            dispatch(actions.setUpdateRoleIsPending(false))
        },
        onSuccess: (res) => {
            const { data } = res || {}
            const nUser = { ...user, default_user_roles: data.default_user_roles }
            secretStorage.setUser(nUser)
            dispatch(actions.setUser(nUser))
        },
        onError: () => {
            toast.error("שגיאה בשמירת תפקיד", toastConfig)
        }
    })

    const selectDefaultRole = useCallback(async (role) => {
        selectRole(role)
        updateDefaultUserRoles(role.user_roles)
    }, [user])

    return selectDefaultRole
}

export default useUpdateDefaultRole